import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Generator from "./pages/Generator";
import Library from "./pages/Library";
import RecipeDetail from "./pages/RecipeDetail";
import Submit from "./pages/Submit";
import Cookbook from "./pages/Cookbook";
import Skills from "./pages/Skills";
import SkillDetail from "./pages/SkillDetail";
import Ingredients from "./pages/Ingredients";
import IngredientDetail from "./pages/IngredientDetail";
import SharedCookbook from "./pages/SharedCookbook";
import Sauces from "./pages/Sauces";
import SauceDetail from "./pages/SauceDetail";
import CookbookManage from "./pages/CookbookManage";
import AdminModeration from "./pages/AdminModeration";
import Subscribe from "./pages/Subscribe";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import Account from "./pages/Account";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/generate" element={<Generator />} />
            <Route path="/library" element={<Library />} />
            <Route path="/recipe/:id" element={<RecipeDetail />} />
            <Route path="/submit" element={<Submit />} />
            <Route path="/cookbook" element={<Cookbook />} />
            <Route path="/cookbook/manage" element={<CookbookManage />} />
            <Route path="/cookbook/shared/:shareId" element={<SharedCookbook />} />
            <Route path="/sauces" element={<Sauces />} />
            <Route path="/sauces/:slug" element={<SauceDetail />} />
            <Route path="/subscribe" element={<Subscribe />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/account" element={<Account />} />
            <Route path="/admin" element={<AdminModeration />} />
            <Route path="/skills" element={<Skills />} />
            <Route path="/skills/:slug" element={<SkillDetail />} />
            <Route path="/ingredients" element={<Ingredients />} />
            <Route path="/ingredients/:slug" element={<IngredientDetail />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
          </Routes>
          <Footer />
          <Toaster
            theme="dark"
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#1c1917",
                border: "1px solid #292524",
                color: "#f5f5f4",
                borderRadius: 0,
                fontFamily: "Outfit, sans-serif",
              },
            }}
          />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
